var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.onScroll),expression:"onScroll"},{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],staticClass:"ContainerScrolling",attrs:{"pa-0":"","fluid":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }